import { render, staticRenderFns } from "./TheAppHeader.vue?vue&type=template&id=61285520&scoped=true&"
import script from "./TheAppHeader.vue?vue&type=script&lang=js&"
export * from "./TheAppHeader.vue?vue&type=script&lang=js&"
import style0 from "./TheAppHeader.vue?vue&type=style&index=0&id=61285520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61285520",
  null
  
)

export default component.exports